import { useState } from "react";
import { motion } from "framer-motion";
import { Copy, Check, Rocket, TrendingUp, TrendingDown } from "lucide-react";
import { toast } from "sonner";
import { usePrice, fmtPrice } from "@/hooks/usePrice";
import { TOKEN, LINKS } from "@/lib/site";
import { SocialLinks } from "./SocialLinks";

export const Header = () => {
  const [copied, setCopied] = useState(false);
  const { data, state, change, up } = usePrice();

  const copyContract = () => {
    navigator.clipboard.writeText(TOKEN.contract);
    setCopied(true);
    toast.success("Contract address copied", { description: TOKEN.contract });
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 h-16 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-3 group" data-testid="logo-link">
          <span className="w-9 h-9 rounded-md bg-[#ff007f] grid place-items-center glow-magenta">
            <Rocket className="w-5 h-5 text-black" />
          </span>
          <span className="font-display font-extrabold text-sm sm:text-base tracking-tight">
            SCREAMING<span className="text-[#00f0ff]">CHICKEN</span>
          </span>
        </a>

        <div className="flex items-center gap-2 sm:gap-3">
          <div
            className="hidden sm:flex items-center gap-2.5 font-mono text-xs px-3 py-2 rounded-md border border-white/10 bg-white/5"
            data-testid="nav-price"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#39ff14] animate-pulse" />
            <span className="font-bold text-white tabular-nums" data-testid="nav-price-value">
              {state === "ok" ? fmtPrice(data.priceUsd) : state === "loading" ? "···" : "--"}
            </span>
            {state === "ok" && (
              <span
                className={`flex items-center gap-0.5 font-bold tabular-nums ${up ? "text-[#39ff14]" : "text-[#ff007f]"}`}
                data-testid="nav-price-change"
              >
                {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                {up ? "+" : ""}
                {change.toFixed(1)}%
              </span>
            )}
          </div>

          <button
            onClick={copyContract}
            data-testid="header-copy-contract"
            className="hidden md:flex items-center gap-2 font-mono text-xs px-3 py-2 rounded-md border border-white/15 hover:border-[#00f0ff] text-white/70 hover:text-white transition-colors"
          >
            {copied ? <Check className="w-3.5 h-3.5 text-[#39ff14]" /> : <Copy className="w-3.5 h-3.5" />}
            {TOKEN.contract.slice(0, 4)}...{TOKEN.contract.slice(-4)}
          </button>
          <SocialLinks compact className="hidden md:flex" />
          <a
            href={LINKS.pumpfun}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-buy-btn"
            className="font-display font-bold text-xs sm:text-sm px-4 sm:px-5 py-2.5 rounded-full bg-[#ff007f] text-black hover:bg-[#ffb800] transition-colors glow-magenta"
          >
            BUY ON PUMP.FUN
          </a>
        </div>
      </div>
    </motion.header>
  );
};
